import {Modal} from 'asteq.modal';
import {DetailModalSlider} from 'asteq.sliders.detailmodalslider';

export class Zoom {
    constructor(params = {}) {
        this.modal = null;
        this.zoomSlider = null;
        this.parent = params.parentSlider;

        this.init(params);
    }

    init(params) {
        const modalEl = document.querySelector('#' + params.modalId);
        if (modalEl) {
            this.modal = new Modal({
                element: modalEl,
            });
        }

        if (this.modal?.el) {
            const zoomSliderEl = this.modal.el.hasAttribute('data-main-swiper')
                ? this.modal.el
                : this.modal.el.querySelector('#' + params.zoomSliderId);
            if (zoomSliderEl) {
                this.zoomSlider = new DetailModalSlider(zoomSliderEl, {});
            }
        }

        if (this.modal && !this._modalCloseBound) {
            this._modalCloseBound = true;
            this.modal.subscribe('close', this.onModalClose.bind(this));
        }
    }

    onModalClose() {
        const engine = window.ProductGallery360;
        if (!engine || !engine.active || !engine.activePreview) {
            return;
        }

        if (engine.activePreview.closest('[data-modal-bg]')) {
            engine.deactivate();
        }
    }

    initParentSlidesEvents() {
        if (!this.parent?.mainSwiper?.slides) {
            return;
        }

        this.parent.mainSwiper.slides.forEach((slide) => {
            if (slide.hasAttribute('data-gallery-360-slide') || slide.querySelector('[data-gallery-360-slide]')) {
                return;
            }
            slide.addEventListener('click', this.onOpenBySlide.bind(this));
        });
    }

    initModalSlidesEvents() {
        if (!this.zoomSlider?.mainSwiper?.slides) {
            return;
        }

        this.zoomSlider.mainSwiper.slides.forEach((slide) => {
            if (slide.hasAttribute('data-gallery-360-slide') || slide.querySelector('[data-gallery-360-slide]')) {
                return;
            }
            const zoomImg = slide.querySelector('img');
            if (zoomImg) {
                zoomImg.classList.add('cursor-zoom-in');
            }
        });
    }

    onOpenBySlide(e) {
        if (window.ProductGallery360 && window.ProductGallery360.active) {
            return;
        }
        const currentIndex = this.parent.mainSwiper.activeIndex;
        this.openGallery(currentIndex);
    }

    openGallery(targetIndex) {
        if (!this.zoomSlider || !this.parent?.imagesSets) {
            return;
        }

        if (window.ProductGallery360 && window.ProductGallery360.active) {
            window.ProductGallery360.deactivate();
        }

        const detailSlider = this.parent;
        const engine = window.ProductGallery360;
        const slideTemplate = engine && typeof engine.getSlideTemplateForSlider === 'function'
            ? engine.getSlideTemplateForSlider(detailSlider)
            : detailSlider.gallery360SlideTemplate;
        const has360 = detailSlider.gallery360Enabled && slideTemplate;
        const thumbs = detailSlider.imagesSets.thumbs ? [...detailSlider.imagesSets.thumbs] : [];
        const slides = detailSlider.imagesSets.details?.length
            ? [...detailSlider.imagesSets.details]
            : (detailSlider.imagesSets.slides ? [...detailSlider.imagesSets.slides] : []);

        if (has360) {
            if (engine && typeof engine.buildSlidePrependHtml === 'function') {
                const gallery360 = detailSlider.imagesSets?.gallery360
                    || (engine.enabled ? {
                        HAS: true,
                        SOURCE_ID: engine.sourceId,
                        POSTER: engine.poster,
                    } : null);

                this.zoomSlider.gallery360PrependHtml = engine.buildSlidePrependHtml(
                    slideTemplate,
                    {
                        modal: true,
                        sourceId: gallery360?.SOURCE_ID || engine.sourceId,
                        poster: gallery360?.POSTER || engine.poster || '',
                    }
                );
            } else {
                this.zoomSlider.gallery360PrependHtml = slideTemplate.outerHTML;
            }
            this.zoomSlider.gallery360Enabled = true;
            this.zoomSlider.gallery360ThumbMarkup = detailSlider.gallery360ThumbMarkup || '';
            this.zoomSlider.gallery360ThumbPoster = detailSlider.gallery360ThumbPoster || '';
        } else {
            this.zoomSlider.gallery360PrependHtml = '';
            this.zoomSlider.gallery360Enabled = false;
        }

        const modalIndex = typeof targetIndex === 'number' ? targetIndex : 0;

        this.zoomSlider.setImages({
            thumbs: thumbs,
            slides: slides,
        }, modalIndex);

        this.modal.open();
        this.initModalSlidesEvents();

        if (window.ProductGallery360) {
            window.ProductGallery360.collectDom();
            if (this.zoomSlider.mainSwiper) {
                window.ProductGallery360.bindSwiperDeactivate(this.zoomSlider.mainSwiper);
            }
        }
    }

    onAfterSetImagesParent(e) {
        this.initParentSlidesEvents();
    }
}
